/*
 * Copyright 2025 iodyne.  All rights reserved.
 * Use is subject to license terms.
 */

import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export interface ModelError {
  userMessage: string,
  errorContents: {[key: string] : any} | null
}

export function makeError(message:string, contents?:{[key: string] : any}):ModelError {
  return {userMessage: message, errorContents:contents ? contents : null} as ModelError;
}

export interface CloudAPIError {
  error_class: string,
  error: string,
  error_description: string
}

export function decodeAPIError(error:FetchBaseQueryError|SerializedError|undefined):CloudAPIError|undefined {
  let query_error = error as FetchBaseQueryError;
  if(query_error?.status) {
    if (query_error.status == 400) {
      //@ts-ignore
      if ("detail" in query_error.data) {
        //@ts-ignore
        return JSON.parse(query_error.data.detail) as CloudAPIError;
      }
    }
    
    return query_error.data as CloudAPIError
  }
  return undefined
}

export function userMessageFromAPIError(error: FetchBaseQueryError | SerializedError | undefined):string|undefined {
  const err_msg = decodeAPIError(error);
  if (err_msg) {
    return err_msg.error_description;
  } else if (error && "userMessage" in error) {
    return error.userMessage as string;
  }

  return undefined;
}